import Vue from 'vue';
import Http from 'vue-resource';

/**
 * For using imported plugin i must call 'use' method
 */
Vue.use(Http);

let instance = null;

class Api {

	/**
	 * Manual request function
	 *
	 * @param {string} method can be get, post, put, delete
	 * @param {string} url is part of the full url
	 * @param {object} data
	 * @returns {Promise.<T>}
	 * @private
	 */
	_request(method, url, data) {

		/**
		 * In a vue-resource, different data for different methods are called differently
		 * For this I rename data object
		 */
		switch (method) {
			case "get":
				data = {"params": data}
				break;
			case "delete":
				data = {"body": data}
				break;
		}

		/**
		 * Returning promise
		 * @url {string} contains concatenated root part with other url part
		 */
		return Vue.http[method](url, data).then(response => response.body.data).catch(this.catchError)
	}

	/**
	 * When promise was rejected that this function will catching error and show
	 * @param {object} error
	 * @private
	 */
	catchError(error) {

		if(error.status === 500) {
			Vue.event.toast('e', "Ошибка сервера")
		} else if(error.status === 403) {
			Vue.event.toast('e', "Доступ запрещен")
		}

		throw error.body.errors
	}

	get(url, data) {
		return this._request('get', url, data)
	}

	post(url, data) {
		return this._request('post', url, data)
	}

	put(url, data) {
		return this._request('put', url, data)
	}

	patch(url, data) {
		return this._request('patch', url, data)
	}

	delete(url, data) {
		return this._request('delete', url, data)
	}

	/**
	 * Standard function for installing custom plugins
	 * @param {object} Vue - base instance
	 */
	static install(Vue) {
		if(!instance) {
			instance = new Api();
		}

		Vue.prototype.$api = instance;
		Vue.api = instance;
	}
}

export default Api;



// WEBPACK FOOTER //
// ./src/libs/requestApi.js